module.exports = __webpack_public_path__ + "static/img/client2_comment.99bc009.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client2_comment.png
// module id = yt92
// module chunks = 1